/**
 * TKP-165 md.4 — satır görünümü sütun süzgeçleri (saf): süzgeç değeri → sayfalama sorgusu yaması.
 * `null` dönerse anahtar sorgudan silinir. Öncelik sayısal, kategori kimlik, son tarih gün aralığı.
 */
export const priorityPatch = (value) => (value === null || value === undefined || value === "" ? null : { priority: { value: Number(value), isObject: true } });

export const categoryPatch = (category) => (category && category._id ? { category: { value: category._id, isObject: true } } : null);
/** TKP-240 b.2 — Görev Tipi sütun süzgeci (yalnız görev tipi etkinken görünür). */
export const typePatch = (type) => (type && type._id ? { type: { value: type._id, isObject: true } } : null);

/** TKP-176 md.50 — oluşturma tarihi başlık sıralaması: yok → artan → azalan → yok. */
export const nextSort = (current) => (!current ? "asc" : current === "asc" ? "desc" : null);
/** Sıralama seçeneği: yön varsa yalnız createdAt; yoksa ekranın varsayılanı (öncelik azalan, numara artan). */
export const DEFAULT_TASK_SORT = { priority: "desc", no: "asc" };
export const sortPatch = (direction) => (direction === "asc" || direction === "desc" ? { createdAt: direction } : { ...DEFAULT_TASK_SORT });

/** [başlangıç, bitiş] → günün başı/sonu; eksik ya da boşsa null. `field`: süzülen tarih alanı. */
export const dateRangePatch = (field, range) => {
  if (!Array.isArray(range) || range.length !== 2 || range.some((d) => !d)) return null;
  const startTime = new Date(range[0]).setHours(0, 0, 0, 0);
  const endTime = new Date(range[1]).setHours(23, 59, 59, 999);
  return { [field]: { value: { $gte: startTime, $lte: endTime }, isObject: true } };
};
export const dueRangePatch = (range) => dateRangePatch("duedate", range);
/** TKP-181 md.50: "Oluşturulma Tarihi" sütun süzgeci (gün aralığı). */
export const createdRangePatch = (range) => dateRangePatch("createdAt", range);

/** Yamayı iki isteğe uygular (Görevlerim + Organizasyon Görevleri): yama null ise anahtar(lar) silinir. */
export const applyPatch = (request, patch, keys) => {
  const query = { ...(request.query || {}) };
  for (const k of keys) delete query[k];
  return { ...request, query: { ...query, ...(patch || {}) } };
};

/**
 * TKP-243 r.1: "Dosyaya indir" ekrandaki süzgeçle — açık sekmenin istek gövdesinin süzgeci ve sıralaması (sayfa bilgisi değil).
 * Boş (null) süzgeç anahtarları gönderilmez.
 */
export const exportPagination = (request) => {
  const query = Object.fromEntries(Object.entries((request && request.query) || {}).filter(([, v]) => v !== null && v !== undefined));
  const sort = (request && request.options && request.options.sort) || undefined;
  return { options: { ...(sort ? { sort: { ...sort } } : {}) }, query };
};
